import { BillDetail } from "./BillDetail";

export const VAPanel = ({ bank, currPeriod, fees, discount, total, copied, onCopy }) => (
  <div className="px-3 pb-3">
    <hr className="mt-0 mb-3" style={{ opacity: 0.15 }} />
    <BillDetail currPeriod={currPeriod} fees={fees} discount={discount} total={total} />
    <div className="d-flex align-items-center gap-2 p-2 rounded bg-body-secondary mt-3">
      <div className="flex-grow-1 overflow-hidden">
        <div className="text-muted mb-1" style={{ fontSize: 11 }}>Nomor {bank.label}</div>
        <div className="fw-semibold text-truncate" style={{ fontSize: 15, letterSpacing: "0.04em" }}>
          {bank.va}
        </div>
      </div>
      <button
        className="btn btn-sm btn-outline-secondary flex-shrink-0"
        onClick={() => onCopy(bank.va, bank.key)}
      >
        <i className={`fa ${copied === bank.key ? "fa-check text-success" : "fa-copy"} me-1`} aria-hidden="true" />
        {copied === bank.key ? "Disalin" : "Salin"}
      </button>
    </div>
  </div>
)